import { useEffect, useState } from "react";

/**
 * Delays a fast-changing value so it can drive a network request.
 * Used for the search box, which would otherwise issue a request per keystroke.
 */
export function useDebouncedValue(value, delayMs = 350) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
